var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoothCurtain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32V496C0 504.75 7.25 512 16 512H48C56.75 512 64 504.75 64 496V64H96V0H32C14.25 0 0 14.25 0 32ZM480 0H448V496C448 504.75 455.25 512 464 512H496C504.75 512 512 504.75 512 496V32C512 14.25 497.75 0 480 0ZM128 396.69C128 422.221 146.462 445.734 171.907 447.831C198.2 449.997 220.253 431.072 224 406.459C227.551 429.783 247.541 448 272 448S316.447 429.785 320 406.461C323.706 430.791 345.296 449.562 371.189 447.897C397.199 446.225 416 421.83 416 395.766L416 0H128L128 396.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoothCurtain);
export default __webpack_public_path__ + "static/media/booth-curtain.625f656777009e50912f758ffeef17f1.svg";
export { ForwardRef as ReactComponent };